import { RouteObject } from "react-router-dom";
import { ChatInbox } from "../pages/admin/chat/ChatInbox";

export const chatRoutes: RouteObject[] = [
  {
    id: "chat-inbox",
    index: true,
    element: <ChatInbox />,
  },
];
